const NAME = "ASSETS_DISCOUNTS_ENTRY_PER_CONCEPT_SET";

export default NAME;
